import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "email",
  "use": "email-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"email\"><path d=\"M3 6.867V17.11l5.897-5.265L3 6.866zM19.973 6H4.027L12 12.732 19.973 6zM12 14.467L9.92 12.71 3.995 18h16.01l-5.926-5.29L12 14.467zm9 2.644V6.867l-5.897 4.979L21 17.111z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol